import React, { useState, useEffect } from 'react'
import Layout from 'components/Layout'
import Locations from './components/Locations/Locations'
import SidebarLocationsRecent from 'components/Sidebars/SidebarLocationsRecent'
import useMediaQuery from 'hooks/useMediaQuery'
import * as _ from 'styles/helpers'

const CARD_DISPLAY_KEY = 'cardDisplayPreference'

const Locations_Index = () => {
	const isMobile = useMediaQuery(_.MQ.before_nav)

	const [cardDisplay, setCardDisplay] = useState(() => {
		const stored = localStorage.getItem(CARD_DISPLAY_KEY)
		return stored === null ? true : stored === 'true'
	})

	useEffect(() => {
		localStorage.setItem(CARD_DISPLAY_KEY, cardDisplay)
	}, [cardDisplay])

	// Force card display on mobile
	const effectiveCardDisplay = isMobile ? true : cardDisplay

	return (
		<Layout>
			<Layout.Page>
				<Layout.Sidebar>
					<SidebarLocationsRecent />
				</Layout.Sidebar>
				<Layout.Body>
					<Layout.PageHeader>
						<h2>Locations</h2>
					</Layout.PageHeader>
					<Locations
						cardDisplay={effectiveCardDisplay}
						onToggleCardDisplay={() => setCardDisplay(!cardDisplay)}
						isMobile={isMobile}
					/>
				</Layout.Body>
			</Layout.Page>
		</Layout>
	)
}

export default Locations_Index
